// extracted by mini-css-extract-plugin
export default {"button":"AdminPageButton_button__6ep1y"};